import OrdersPage from 'pages/OrdersPage';
import OrderDetailsPage from 'pages/OrderDetailsPage';
import VendorsPage from 'pages/VendorsPage';
import MasterListPage from 'pages/MasterListPage';

const routes = {
  public: [],
  private: [
    {
      path: '/orders',
      component: <OrdersPage />,
    },
    {
      path: '/order/:id',
      component: <OrderDetailsPage />,
    },
    {
      path: '/vendors',
      component: <VendorsPage />,
    },
    {
      path: '/masterlist',
      component: <MasterListPage />,
    },
  ],
};

export default routes;
